import styled, { css } from 'styled-components';

type Size = 'sm' | 'md' | 'lg' | number;

interface Props {
  size?: Size;
  color?: string;
  hollow?: boolean;
  triangle?: boolean;
}

const getSize = (size?: Size) => {
  if (typeof size === 'number') {
    return `${size}px`;
  }

  switch (size) {
    case 'sm':
      return '0.5em';
    case 'md':
      return '0.75em';
    case 'lg':
      return '1em';
    default:
      return '0.75em';
  }
};

export const Dot = styled.div`
  width: ${(props: Props) => getSize(props.size)};
  height: ${(props: Props) => getSize(props.size)};
  background: ${(props: Props) => props.color || 'gray'};
  border-radius: 100%;
  display: inline-block;
  vertical-align: middle;
  margin: -3px 0.5em 0 0.5em;

  ${(props: Props) =>
    props.hollow &&
    css`
      background: white;
      border: 2px solid ${props.color || 'gray'};
      border-radius: 50%;
    `}

  ${(props: Props) =>
    props.triangle &&
    css`
      width: 0;
      height: 0;
      background: transparent;
      border-left: calc(0.8 * ${getSize(props.size)}) solid transparent;
      border-right: calc(0.8 * ${getSize(props.size)}) solid transparent;
      border-bottom: ${getSize(props.size)} solid ${props.color || 'gray'};
      border-radius: 0;
    `}
  padding: 0 !important;
`;
